import { useState } from "react";
import { Link, useHistory } from "react-router-dom";

function Register() {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setMessageType("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name,
            username,
            email,
            password,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        setMessage(data.message || "Գրանցումը չհաջողվեց");
        setMessageType("error");
        return;
      }

      setMessage("Գրանցումը հաջողությամբ կատարվեց");
      setMessageType("success");

      setTimeout(() => {
        history.push("/login");
      }, 1500);
    } catch (error) {
      console.error(error);

      setMessage("Սերվերի հետ կապի սխալ");
      setMessageType("error");
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Գրանցվել</h1>

        {message && (
          <div className={`auth-message ${messageType}`}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Անուն"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Էլ․ փոստ"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Գաղտնաբառ"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit">
            Գրանցվել
          </button>
        </form>

        <p>
          Արդեն ունե՞ս հաշիվ։{" "}
          <Link to="/login">
            Մուտք գործել
          </Link>
        </p>
      </div>
    </div>
  );
}

export default Register;